// =============================================================================
// API client for table: public.cost_model_analysis
// Replaces localStorage key: "spendiq_cost_model_result"
// =============================================================================
import { apiRequest } from "./apiClient";


/** INSERT a new row after each successful cost model run */
export async function saveCostModelAnalysis(payload: {
  request_id?: string;
  input_data: unknown;
  output_data: unknown;
  model_name?: string;
  processing_status?: string;
  agent_type?: string;
  is_standalone?: boolean;
}) {
  // apiRequest already resolves to the parsed JSON body, not a Response.
  return apiRequest("/api/cost-model-analysis", {
    method: "POST",
    body: JSON.stringify(payload),
  });
}

/** Main UI data = newest SUCCESS row only */
export async function fetchLatestCostModelAnalysis() {
  return apiRequest("/api/cost-model-analysis-latest");
}

/** List rows from cost_model_analysis, optionally filtered by is_standalone */
export async function fetchCostModelAnalysisList(isStandalone?: boolean) {
  const query = isStandalone === undefined ? "" : `?is_standalone=${isStandalone}`;
  // apiRequest already resolves to the parsed JSON array/body, not a Response.
  return apiRequest(`/api/cost-model-analysis${query}`);
}

/** Fetch a single cost_model_analysis row by id */
export async function fetchCostModelAnalysisById(id: string | number) {
  return apiRequest(`/api/cost-model-analysis/${id}`);
}

/**
 * Latest cleaned spend rows from spend_data_cleaning_results.
 * Used as input_data when saving cost_model_analysis.
 */
export async function fetchLatestSpendCleaning() {
  // Backend returns an array: SELECT ... LIMIT 1 → [row]
  const data = await apiRequest("/api/spend-cleaning-latest/");
  const row = Array.isArray(data) ? data[0] : data;
  return row ?? null;
}